import React, { useEffect, useState } from 'react';
import { Breadcrumb, Button, Flex} from 'antd';
import { CollapsedIcon } from '../../assets/image/svg';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import socket from '../../socket';
import { useTranslation } from 'react-i18next';


interface HeaderComponentProps {
  setCollapsed: (value: (((prevState: boolean) => boolean) | boolean)) => void,
  collapsed: boolean
}

const Index = ({ setCollapsed, collapsed }: HeaderComponentProps) => {
  const { t, i18n } = useTranslation();
  const breadcrumb = useSelector((state: RootState) => state.bids.breadcrumb);
  const [breadcrumbs, setBreadcrumbs] = useState<any[]>([]);

  useEffect(() => {
    if (breadcrumb.length > 0 ) {
      setBreadcrumbs([{ title: t('Bids') }, { title: t('Current') }]);
    } else {
      setBreadcrumbs([{ title: t('Bids') }, { title: t('Current') }]);
    }
    socket.on('return-search-bits', resSearchBits);
    return () => {
      socket.on('return-get-filters-bits', resSearchBits);
    };
  }, [breadcrumb]);

  const resSearchBits = () => {};

  return (
    <Flex align={'center'} justify={'space-between'}>
      <Flex justify="space-between" align={'center'}>
        {
          collapsed &&
          <Button type="text" icon={<CollapsedIcon />}
                  onClick={() => setCollapsed(!collapsed)} />
        }
        <Breadcrumb separator={<span className="circle" />} items={breadcrumb.length == 0 ?  breadcrumbs : breadcrumb} />
      </Flex>
    </Flex>
  );
};

export default Index;
